module.exports = __webpack_public_path__ + "static/media/blue-pdf.d24b62d7.svg";